import {Component, forwardRef, Inject, ViewChild} from '@angular/core';
import {BaseModalComponent} from '../../../components/base.modal.component';
import {FieldsListComponent} from '../../../components/fields-list.component';
import {Field} from '../../../common/field';
import {UserBean} from '../../../model/model';
import {CategoryNotificationEmailsComponent} from './category-notification-emails.component';
import {AppComponent} from '../../../app.component';
import {Helper} from '../../../common/helper';

@Component({
    selector: 'category-notification-emails-edit-component',
    templateUrl: 'category-notification-emails.edit.component.html'
})

export class CategoryNotificationEmailsEditComponent {

    @ViewChild(BaseModalComponent, {static: false}) base: BaseModalComponent;
    @ViewChild(FieldsListComponent, {static: false}) fieldsListComponent: FieldsListComponent;

    user: UserBean = {} as UserBean;

    fields: Field[] = [
        new Field('email', 'Email').require(),
    ];
    initUser: UserBean;

    isValid() {
        return () => {
            return this.fieldsListComponent && this.fieldsListComponent.valid();
        };
    }

    constructor(@Inject(forwardRef(() => CategoryNotificationEmailsComponent)) private parent: CategoryNotificationEmailsComponent,
        @Inject(forwardRef(() => AppComponent)) private app: AppComponent) {
    }

    open(user: UserBean, title: string) {
        this.base.show(title);
        this.user = user ? Helper.copyObject(user) : {} as UserBean;
        this.initUser = user ? Helper.copyObject(user) : {} as UserBean;
    }

    save() {
        this.parent.addUser(this.initUser, this.user);
    }

}
